// src/data/quartiers.js
// Quartiers camerounais - NE PAS MODIFIER

export const QUARTIERS = [
    // Douala
    {
      id: 1,
      name: 'Bonapriso',
      city: 'Douala',
      category: 'commercial',
      description: 'Quartier commerçant et résidentiel très dynamique',
      lat: 4.0511,
      lng: 9.7679,
      imageUrl: '/images/quartiers/bonapriso.jpg',
    },
    {
      id: 2,
      name: 'Bastos',
      city: 'Douala',
      category: 'residential',
      description: 'Zone résidentielle haut de gamme et sécurisée',
      lat: 4.0287,
      lng: 9.7546,
      imageUrl: '/images/quartiers/bastos.jpg',
    },
    {
      id: 3,
      name: 'Akwa',
      city: 'Douala',
      category: 'commercial',
      description: 'Centre-ville dynamique avec commerces et services',
      lat: 4.0541,
      lng: 9.7506,
      imageUrl: '/images/quartiers/akwa.jpg',
    },
    {
      id: 4,
      name: 'Bonanjo',
      city: 'Douala',
      category: 'commercial',
      description: 'Quartier d\'affaires principal de Douala',
      lat: 4.0397,
      lng: 9.7347,
      imageUrl: '/images/quartiers/bonanjo.jpg',
    },
    {
      id: 5,
      name: 'New Bell',
      city: 'Douala',
      category: 'residential',
      description: 'Zone résidentielle populaire et accessible',
      lat: 4.0287,
      lng: 9.7718,
      imageUrl: '/images/quartiers/newbell.jpg',
    },
    {
      id: 6,
      name: 'Deido',
      city: 'Douala',
      category: 'residential',
      description: 'Quartier résidentiel avec accès à la mer',
      lat: 4.0083,
      lng: 9.7428,
      imageUrl: '/images/quartiers/deido.jpg',
    },
    {
      id: 7,
      name: 'Logpom',
      city: 'Douala',
      category: 'residential',
      description: 'Quartier résidentiel en expansion',
      lat: 3.9785,
      lng: 9.7852,
      imageUrl: '/images/quartiers/logpom.jpg',
    },
    {
      id: 8,
      name: 'Ndogpassi',
      city: 'Douala',
      category: 'residential',
      description: 'Zone semi-résidentielle et commerciale',
      lat: 4.0185,
      lng: 9.8051,
      imageUrl: '/images/quartiers/ndogpassi.jpg',
    },
  
    // Yaoundé
    {
      id: 9,
      name: 'Plateau Atemengue',
      city: 'Yaoundé',
      category: 'residential',
      description: 'Quartier résidentiel chic et sécurisé',
      lat: 3.8667,
      lng: 11.5167,
      imageUrl: '/images/quartiers/atemengue.jpg',
    },
    {
      id: 10,
      name: 'Mvog-Mbi',
      city: 'Yaoundé',
      category: 'commercial',
      description: 'Centre-ville avec commerces et services',
      lat: 3.8577,
      lng: 11.5065,
      imageUrl: '/images/quartiers/mvogmbi.jpg',
    },
    {
      id: 11,
      name: 'Tsinga',
      city: 'Yaoundé',
      category: 'residential',
      description: 'Quartier résidentiel moderne et développé',
      lat: 3.8421,
      lng: 11.5256,
      imageUrl: '/images/quartiers/tsinga.jpg',
    },
    {
      id: 12,
      name: 'Omnisports',
      city: 'Yaoundé',
      category: 'residential',
      description: 'Zone résidentielle avec équipements publics',
      lat: 3.8487,
      lng: 11.5187,
      imageUrl: '/images/quartiers/omnisports.jpg',
    },
    {
      id: 13,
      name: 'Etoudi',
      city: 'Yaoundé',
      category: 'residential',
      description: 'Quartier semi-résidentiel et commercial',
      lat: 3.8354,
      lng: 11.5012,
      imageUrl: '/images/quartiers/etoudi.jpg',
    },
    {
      id: 14,
      name: 'Bastos',
      city: 'Yaoundé',
      category: 'residential',
      description: 'Zone haut de gamme avec ambassades',
      lat: 3.8298,
      lng: 11.4874,
      imageUrl: '/images/quartiers/bastos-yde.jpg',
    },
  
    // Bafoussam
    {
      id: 15,
      name: 'Centre-ville',
      city: 'Bafoussam',
      category: 'commercial',
      description: 'Centre commercial principal de Bafoussam',
      lat: 5.7632,
      lng: 10.4159,
      imageUrl: '/images/quartiers/bafoussam-centre.jpg',
    },
    {
      id: 16,
      name: 'Kamtar',
      city: 'Bafoussam',
      category: 'residential',
      description: 'Quartier résidentiel en expansion',
      lat: 5.7521,
      lng: 10.4201,
      imageUrl: '/images/quartiers/kamtar.jpg',
    },
  
    // Kumba
    {
      id: 17,
      name: 'Centre-ville',
      city: 'Kumba',
      category: 'commercial',
      description: 'Centre commercial principal de Kumba',
      lat: 5.9269,
      lng: 9.7487,
      imageUrl: '/images/quartiers/kumba-centre.jpg',
    },
  ];
  
  // Index par ville pour recherche rapide
  export const QUARTIERS_BY_CITY = QUARTIERS.reduce((acc, q) => {
    if (!acc[q.city]) acc[q.city] = [];
    acc[q.city].push(q);
    return acc;
  }, {});
  
  // Fonction pour obtenir quartiers par ville
  export const getQuartiersByCity = (city) => QUARTIERS_BY_CITY[city] || [];
  
  // Fonction pour chercher un quartier par nom (case-insensitive)
  export const searchQuartier = (query) => {
    const q = query.toLowerCase();
    return QUARTIERS.filter(
      (quartier) =>
        quartier.name.toLowerCase().includes(q) ||
        quartier.city.toLowerCase().includes(q)
    );
  };
  
  // Fonction pour obtenir un quartier par ID
  export const getQuartierById = (id) => QUARTIERS.find((q) => q.id === id);
  
  // Villes disponibles
  export const CITIES = Array.from(new Set(QUARTIERS.map((q) => q.city)));